import { ToastContentProps } from "react-toastify"

import classNames from "classnames"

import { IconSize } from "shared/types/Icon"
import { ToastModel as IToast, ToastType } from "shared/types/Toast"
import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"
import { LoadingSpinner } from "shared/ui/loading-spinner/LoadingSpinner"

import I18n from "i18n"

import "./styles/_toast.scss"

interface ToastProps extends Partial<ToastContentProps> {
  data: IToast
}

export function Toast({ data, closeToast }: ToastProps) {
  const { message, id, type } = data

  return (
    <div
      id={id}
      data-testid={`${type.toLocaleLowerCase()}-toast`}
      className={classNames(getToastClassName(type))}
      role={getAriaRole(type)}
      aria-live={getAriaLive(type)}
      aria-atomic="true"
      aria-label={message}
    >
      {closeToast ? (
        <button
          type="button"
          onClick={closeToast}
          className="toast-button"
          aria-label={`${I18n.t("live:General.Close")} ${message}` as string}
        >
          <div className="d-flex gap-2 align-items-center justify-content-between w-100">
            <div className="d-flex gap-2 align-items-center">
              <div className="message">{message}</div>
              {type === ToastType.LOADING ? (
                <LoadingSpinner
                  small
                  aria-label={I18n.t("live:General.Loading")}
                />
              ) : null}
            </div>
            <Icon
              name={IconName.CLOSE}
              size={IconSize.SMALL}
              aria-hidden
              className="toast-close-icon"
            />
          </div>
        </button>
      ) : (
        <div className="d-flex gap-2 align-items-center">
          <div className="message">{message}</div>
          {type === ToastType.LOADING ? (
            <LoadingSpinner small aria-hidden />
          ) : null}
        </div>
      )}
    </div>
  )
}

export function getToastClassName(type: ToastType) {
  switch (type) {
    case ToastType.SUCCESS:
      return "alert alert-success notification"
    case ToastType.ERROR:
      return "alert alert-danger notification"
    case ToastType.LOADING:
    case ToastType.INFO:
      return "alert alert-info notification"
    case ToastType.ACCESSIBILITY:
      return "visually-hidden"
    default:
      return "alert alert-info notification"
  }
}

const getAriaRole = (type: ToastType) => {
  switch (type) {
    case ToastType.ERROR:
      return "alert"
    default:
      return "status"
  }
}

const getAriaLive = (type: ToastType) => {
  switch (type) {
    case ToastType.ERROR:
      return "assertive"
    default:
      return "polite"
  }
}
